<template>
  <div id="leftTop">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <div class="d-flex">
          <span class="fs-xl text mx-2">数据概况</span>
          <dv-decoration-3 class="dv-dec-3" />
        </div>
      </div>
      <div class="d-flex ai-center flex-column ">
        <LeftTopChart
          :id="rate[0].id"
          :cdata="rate[0].cdata"
          :tit="rate[0].tit"
        />
        <LeftTopChart
          :id="rate[1].id"
          :cdata="rate[1].cdata"
          :tit="rate[1].tit"
        />
        <div class="ma-dv">
          <LeftTopChart2/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftTopChart from "./components/leftTopChart";
import LeftTopChart2 from "./components/leftTopChart2";
export default {
  components: {
    LeftTopChart,
    LeftTopChart2
  },
  data() {
    return {
      rate: [
        {
          id: "leftTopChart1",
          cdata: "00121",
          tit: "钥匙总数"
        },
        {
          id: "leftTopChart2",
          cdata: "01010",
          tit: "智能锁数"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
$box-height: 640px;
$box-width: 550px;
#leftTop {
  padding: 16px;
  height: $box-height;
  width: $box-width;
  border-radius: 10px;
  .bg-color-black {
    height: $box-height - 30px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .dv-dec-3 {
    position: relative;
    width: 100px;
    height: 20px;
    top: -3px;
  }

  .bottom-data {
    .item-box {
      & > div {
        padding-right: 5px;
      }
      font-size: 14px;
      float: right;
      position: relative;
      width: 50%;
      color: #d3d6dd;
      .dv-digital-flop {
        width: 120px;
        height: 30px;
      }
      // 金币
      .coin {
        position: relative;
        top: 6px;
        font-size: 20px;
        color: #ffc107;
      }
      .colorYellow {
        color: yellowgreen;
      }
      p {
        text-align: center;
      }
    }
  }
}
.ma-dv {
  display: flex;
  .m-dv {
    margin: 60px 15px;
    width: 200px;
    height: 320px;
  }
}
.m-div {
    margin: 90px 50px;
    font-size: 22px;
    p {
      padding: 16px;
    }
    span {
      font-size: 34px;
      color: #ffc107;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/screen/LeftTop.vue